<template>
  <div class="content-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CustomerPageContainer"
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.content-container {
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  row-gap: $spacing-md;
}
</style>
